import { Bar } from '@ant-design/charts';
import { Spin, TreeSelect } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconEmpty from '../../assets/Images/icons/empty';
import RopaService from '../../services/Ropa.service';

export default function Dashboard4({ mDepartment, admin, isLoading }) {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const [department, setDepartment] = useState([]);
    const [selectedRopaValues, setSelectedRopaValues] = useState([]);

    useEffect(() => {
        let defaultSelected = [];
        mDepartment.forEach((element) => {
            defaultSelected.push(element.departmentId);
        });
        setSelectedRopaValues([...defaultSelected]);
    }, [mDepartment]);

    useEffect(() => {
        if (selectedRopaValues.length > 0) {
            getDepartmentRopa();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRopaValues]);

    const getDepartmentRopa = async () => {
        const departmentIds = selectedRopaValues.toString();
        try {
            const { data } = await RopaService.getDepartmentRopa({
                departmentIds: departmentIds,
            });
            setDepartment(data.resultData);
        } catch (err) {
            console.log(err);
        }
    };

    const mvalues = mDepartment?.map((x) => {
        return {
            title: lang === 'en' ? x.nameEn : x.nameTh,
            value: x.departmentId,
        };
    });

    const allRopaIds = mvalues.map(({ value }) => value);

    const config = useMemo(() => {
        return {
            data: department,
            xField: 'ropaTotal',
            yField: lang === 'en' ? 'departmentEn' : 'departmentTh',
            yAxis: {
                label: {
                    autoRotate: false,
                },
            },
            // scrollbar: {
            //     type: 'vertical',
            // },
            color: '#826AF9',
            barStyle: {
                radius: [20, 20, 0, 0],
            },
            label: {
                position: 'right',
                offset: 8,
                style: {
                    fill: '#826AF9',
                    fontWeight: '600',
                },
            },
            minBarWidth: 20,
            maxBarWidth: 20,
            tooltip: {
                formatter: (datum) => ({
                    name: `RoPA (Total)`,
                    value: `${datum.ropaTotal}`,
                }),
            },
        };
    }, [department, lang]);

    return (
        <Spin spinning={isLoading}>
            <div className="grid grid-cols-7 mb-6">
                <div className="col-span-5">
                    <span className="font-semibold text-xl">
                        {t('DIDashBoard.RoPAList')}
                    </span>
                </div>
                <div className="col-span-2">
                    {admin && (
                        <TreeSelect
                            className="w-full"
                            allowClear={true}
                            treeCheckable={true}
                            showCheckedStrategy={TreeSelect.SHOW_CHILD}
                            placeholder={t('Please select department')}
                            filterTreeNode={(search, item) => {
                                return (
                                    String(item?.title)
                                        ?.toLowerCase()
                                        ?.indexOf(search?.toLowerCase()) >= 0
                                );
                            }}
                            // style={{ width: "180px" }}
                            dropdownStyle={{ maxHeight: '300px' }}
                            onChange={(ids) => setSelectedRopaValues(ids)}
                            value={selectedRopaValues}
                            maxTagCount={0}
                            maxTagPlaceholder={(omittedValues) =>
                                `+ ${omittedValues.length} ${t(
                                    'Departments'
                                )} ...`
                            }
                            selectable={true}
                            treeData={[
                                {
                                    title:
                                        selectedRopaValues.length > 0 ? (
                                            <button
                                                type="button"
                                                onClick={() =>
                                                    setSelectedRopaValues([])
                                                }
                                                style={{
                                                    display: 'inline-block',
                                                    color: '#286FBE',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {t('DIDashBoard.UnselectAll')}
                                            </button>
                                        ) : (
                                            <button
                                                type="button"
                                                onClick={() =>
                                                    setSelectedRopaValues(
                                                        allRopaIds
                                                    )
                                                }
                                                style={{
                                                    display: 'inline-block',
                                                    color: '#286FBE',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {t('DIDashBoard.SelectAll')}
                                            </button>
                                        ),
                                    value: 'xxx',
                                    disableCheckbox: true,
                                    disabled: true,
                                    checkable: false,
                                },
                                ...mvalues,
                            ]}
                        />
                    )}
                </div>
            </div>
            {selectedRopaValues?.length > 0 ? (
                <Bar {...config} />
            ) : (
                <div className="h-[30vh] flex justify-center items-center">
                    <IconEmpty />
                </div>
            )}
        </Spin>
    );
}
